import { IsoPen, mix, PAL, propItem, rng, shade, SHADE_LEFT, SHADE_RIGHT } from './paint';
// ---------------------------------------------------------------- floor tiles
/** 1x1 floor tile: 64x32 diamond with ~0.6 px overdraw so seams never show. Anchor = bottom vertex. */
function floorItem(key, base, detail, seed) {
    return {
        key,
        w: 66,
        h: 34,
        anchorX: 33,
        anchorY: 33,
        draw: (g) => {
            g.poly([33, 0.4, 65.6, 17, 33, 33.6, 0.4, 17], true).fill(base);
            const at = (u, v) => [33 + (u - v) * 32, 1 + (u + v) * 16];
            detail(g, at, rng(seed));
        },
    };
}
function specks(g, at, r, n, colors, size, alpha = 1) {
    for (let i = 0; i < n; i++) {
        const [x, y] = at(0.06 + r() * 0.88, 0.06 + r() * 0.88);
        const s = size * (0.5 + r());
        g.ellipse(x, y, s, s * 0.6).fill({ color: colors[Math.floor(r() * colors.length)], alpha });
    }
}
function floorItems() {
    const out = [];
    for (let i = 0; i < 4; i++) {
        const base = mix(PAL.laterite, i % 2 ? PAL.lateriteLight : PAL.lateriteDark, 0.12 + i * 0.05);
        out.push(floorItem(`floor/laterite/${i}`, base, (g, at, r) => {
            specks(g, at, r, 14, [PAL.lateriteDark, PAL.dust, PAL.lateriteLight], 1.1, 0.8);
            if (i === 3)
                specks(g, at, r, 3, [0x6f6a60, 0x8d877b], 1.8); // pebbles
        }, 100 + i));
    }
    for (let i = 0; i < 2; i++) {
        out.push(floorItem(`floor/cement/${i}`, mix(PAL.cement, PAL.cementDark, i * 0.15), (g, at, r) => {
            specks(g, at, r, 10, [PAL.cementDark, 0xc9bfae], 0.8, 0.6);
            if (i === 1) {
                const [x0, y0] = at(0.2, 0.3);
                const [x1, y1] = at(0.55, 0.45);
                const [x2, y2] = at(0.7, 0.8);
                g.moveTo(x0, y0).lineTo(x1, y1).lineTo(x2, y2).stroke({ width: 0.6, color: 0x6e6559, alpha: 0.7 });
            }
        }, 200 + i));
    }
    out.push(floorItem('floor/room/0', PAL.roomTile, (g, at) => {
        // Terrazzo-ish 2x2 tiles with grout lines.
        for (let a = 0; a < 2; a++) {
            for (let b = 0; b < 2; b++) {
                if ((a + b) % 2 === 0)
                    continue;
                const p = [at(a / 2, b / 2), at((a + 1) / 2, b / 2), at((a + 1) / 2, (b + 1) / 2), at(a / 2, (b + 1) / 2)];
                g.poly(p.flat(), true).fill(shade(PAL.roomTile, 0.9));
            }
        }
        const [ax, ay] = at(0.5, 0);
        const [bx, by] = at(0.5, 1);
        const [cx, cy] = at(0, 0.5);
        const [dx, dy] = at(1, 0.5);
        g.moveTo(ax, ay).lineTo(bx, by).moveTo(cx, cy).lineTo(dx, dy).stroke({ width: 0.5, color: 0x9d8f78, alpha: 0.7 });
    }, 300));
    for (let i = 0; i < 3; i++) {
        out.push(floorItem(`floor/asphalt/${i}`, mix(PAL.asphalt, PAL.asphaltLight, i * 0.12), (g, at, r) => {
            specks(g, at, r, 16, [0x6b655f, 0x3a3734, 0x7a736b], 0.7, 0.8);
        }, 400 + i));
    }
    out.push(floorItem('floor/kerb/0', PAL.kerb, (g, at, r) => {
        specks(g, at, r, 8, [0x8f887c], 0.7, 0.6);
        const [x0, y0] = at(0, 0.85);
        const [x1, y1] = at(1, 0.85);
        g.moveTo(x0, y0).lineTo(x1, y1).stroke({ width: 1, color: 0x7d766b, alpha: 0.8 });
    }, 500));
    out.push(floorItem('floor/gutter/0', PAL.kerb, (g, at) => {
        const p = [at(0, 0.22), at(1, 0.22), at(1, 0.78), at(0, 0.78)];
        g.poly(p.flat(), true).fill(PAL.gutter);
        const q = [at(0, 0.42), at(1, 0.42), at(1, 0.6), at(0, 0.6)];
        g.poly(q.flat(), true).fill({ color: 0x4d5a3a, alpha: 0.8 }); // murky water
    }, 600));
    out.push(floorItem('floor/slab/0', shade(PAL.cement, 0.95), (g, at) => {
        for (const t of [0.33, 0.66]) {
            const [x0, y0] = at(t, 0);
            const [x1, y1] = at(t, 1);
            g.moveTo(x0, y0).lineTo(x1, y1).stroke({ width: 0.6, color: 0x7a7266, alpha: 0.8 });
        }
    }, 700));
    for (let i = 0; i < 2; i++) {
        out.push(floorItem(`floor/grass/${i}`, mix(PAL.grass, PAL.laterite, 0.1 + i * 0.15), (g, at, r) => {
            for (let k = 0; k < 12; k++) {
                const [x, y] = at(0.08 + r() * 0.84, 0.08 + r() * 0.84);
                g.moveTo(x, y).lineTo(x - 1 + r() * 2, y - 2.5 - r() * 2).stroke({ width: 0.8, color: r() < 0.5 ? PAL.grassDark : 0x8fae4c });
            }
            specks(g, at, r, 3, [PAL.lateriteDark], 1.2, 0.6);
        }, 800 + i));
    }
    for (let i = 0; i < 2; i++) {
        out.push(floorItem(`floor/market/${i}`, mix(PAL.market, PAL.lateriteDark, i * 0.15), (g, at, r) => {
            specks(g, at, r, 12, [PAL.lateriteDark, PAL.dust], 1, 0.7);
            // pure-water sachets and paper bits
            for (let k = 0; k < 2 + i; k++) {
                const [x, y] = at(0.15 + r() * 0.7, 0.15 + r() * 0.7);
                g.rect(x, y, 2.2, 1.3).fill({ color: r() < 0.6 ? 0xf2f2ee : 0x6aa0d8, alpha: 0.85 });
            }
        }, 900 + i));
    }
    return out;
}
// --------------------------------------------------------------------- decals
function decalItems() {
    const tile = (key, draw) => ({ key, w: 66, h: 34, anchorX: 33, anchorY: 33, draw });
    return [
        tile('decal/marker', (g) => {
            g.poly([33, 4, 61, 17, 33, 30, 5, 17], true).stroke({ width: 2, color: 0xffffff, alpha: 0.95 });
            g.poly([33, 11, 47, 17, 33, 23, 19, 17], true).fill({ color: 0xffffff, alpha: 0.5 });
        }),
        tile('decal/puddle', (g) => {
            g.ellipse(33, 17, 20, 8).fill({ color: 0x4f5f66, alpha: 0.55 });
            g.ellipse(29, 15, 8, 2.5).fill({ color: 0xbfd4dc, alpha: 0.35 });
        }),
        tile('decal/oil', (g) => g.ellipse(34, 18, 14, 6).fill({ color: 0x1d1a18, alpha: 0.45 })),
        tile('decal/pothole', (g) => {
            g.ellipse(33, 17, 16, 7).fill({ color: 0x6d655d, alpha: 0.9 });
            g.ellipse(33, 18, 13, 5.5).fill({ color: 0x2b2826, alpha: 0.95 });
        }),
        tile('decal/litter', (g) => {
            const r = rng(77);
            for (let i = 0; i < 6; i++)
                g.rect(14 + r() * 36, 9 + r() * 14, 2.5, 1.5).fill({ color: [0xf2f2ee, 0x6aa0d8, 0xd94f3d][i % 3], alpha: 0.9 });
        }),
        tile('decal/mat', (g) => {
            g.poly([33, 9, 50, 17, 33, 25, 16, 17], true).fill(0x7a3b2a);
            g.poly([33, 12, 44, 17, 33, 22, 22, 17], true).stroke({ width: 0.8, color: 0xd9a35b });
        }),
    ];
}
// ---------------------------------------------------------------------- walls
const WALL_H = 96;
const LOW_H = 12;
const CAP_T = 0.07;
const WM = 2;
/** Wall segment frames. N edge runs along +x (face looks +y), W edge along +y (face looks +x). */
function wallItem(key, edge, color, height, window) {
    const w = 32 + 3 + WM * 2;
    const h = height + 16 + 3 + WM * 2;
    const ox = edge === 'N' ? WM : WM + 32 + 3;
    const oy = WM + height + 3;
    return {
        key,
        w,
        h,
        anchorX: ox + (edge === 'N' ? 16 : -16),
        anchorY: oy + 16,
        draw: (g) => {
            const pen = new IsoPen(g, ox, oy);
            const face = shade(color, edge === 'N' ? SHADE_LEFT : SHADE_RIGHT);
            // Points along the wall: a(t) = start + t * dir.
            const P = (t, z) => (edge === 'N' ? [t, 0, z] : [0, t, z]);
            pen.poly([...P(0, 0), ...P(1, 0), ...P(1, height), ...P(0, height)], face);
            // Red-earth splash band: rain throws laterite onto every wall in Enugu.
            const band = Math.min(10, height);
            pen.poly([...P(0, 0), ...P(1, 0), ...P(1, band), ...P(0, band)], mix(face, PAL.dirtBand, 0.5));
            if (height > 20)
                pen.poly([...P(0, band), ...P(1, band), ...P(1, band + 7), ...P(0, band + 7)], mix(face, PAL.dirtBand, 0.2));
            // Top cap (wall thickness goes "behind" the edge line).
            const C = (t) => (edge === 'N' ? [t, -CAP_T, height] : [-CAP_T, t, height]);
            pen.poly([...C(0), ...C(1), ...P(1, height), ...P(0, height)], shade(color, 1.12));
            // Segment seams.
            pen.line(...P(0, 0), ...P(0, height), shade(face, 0.8), 0.6, 0.6);
            if (window && height > 60) {
                const z0 = 38;
                const z1 = 74;
                pen.poly([...P(0.2, z0 - 2), ...P(0.8, z0 - 2), ...P(0.8, z1 + 2), ...P(0.2, z1 + 2)], 0x4a4038);
                pen.poly([...P(0.24, z0), ...P(0.76, z0), ...P(0.76, z1), ...P(0.24, z1)], 0x2b3a47);
                pen.poly([...P(0.24, z1 - 10), ...P(0.5, z1 - 10), ...P(0.5, z1), ...P(0.24, z1)], 0x3c5163); // sky reflection
                // Burglar-proof bars.
                for (let i = 1; i < 6; i++) {
                    const t = 0.24 + (0.52 * i) / 6;
                    pen.line(...P(t, z0), ...P(t, z1), 0x8c8c86, 0.9);
                }
                pen.line(...P(0.24, (z0 + z1) / 2), ...P(0.76, (z0 + z1) / 2), 0x8c8c86, 0.9);
            }
        },
    };
}
export const WALL_STYLES = {
    'wall/cream': PAL.wallCream,
    'wall/blue': PAL.wallBlue,
    'wall/pink': PAL.wallPink,
    'wall/block': PAL.wallBlock,
};
function wallItems() {
    const out = [];
    for (const [style, color] of Object.entries(WALL_STYLES)) {
        for (const edge of ['N', 'W']) {
            out.push(wallItem(`${style}/${edge}/plain`, edge, color, WALL_H, false));
            out.push(wallItem(`${style}/${edge}/window`, edge, color, WALL_H, true));
            out.push(wallItem(`${style}/${edge}/low`, edge, color, LOW_H, false));
        }
    }
    return out;
}
// ---------------------------------------------------------------------- props
function legs(pen, x, y, w, h, height, t, color) {
    for (const [lx, ly] of [[x, y], [x + w - t, y], [x, y + h - t], [x + w - t, y + h - t]])
        pen.box(lx, ly, 0, t, t, height, color);
}
function propItems() {
    const items = [];
    const add = (key, w, h, height, draw, margin) => {
        items.push(propItem(key, w, h, height, draw, margin));
    };
    add('prop/bed', 1, 2, 40, (p) => {
        p.box(0.04, 0.02, 0, 0.92, 0.1, 34, PAL.wood); // headboard (back, -y side)
        p.box(0.06, 0.1, 0, 0.88, 1.86, 9, PAL.wood);
        p.box(0.08, 0.12, 9, 0.84, 1.8, 7, 0xeae3d6);
        p.top(0.1, 0.9, 16.1, 0.8, 0.95, 0x2f6aa8); // wrapper as a blanket
        const r = rng(5);
        for (let i = 0; i < 10; i++)
            p.top(0.12 + r() * 0.7, 0.95 + r() * 0.8, 16.2, 0.06, 0.06, 0xf2c14e);
        p.box(0.18, 0.16, 16, 0.64, 0.3, 5, 0xf6f1e8); // pillow
    });
    add('prop/mattress', 1, 2, 14, (p) => {
        p.box(0.06, 0.05, 0, 0.88, 1.9, 9, 0xd5c7ae);
        p.top(0.08, 0.6, 9.1, 0.84, 1.2, 0x9e3a4a);
        p.box(0.16, 0.1, 9, 0.68, 0.3, 4, 0xf3eee4);
    });
    add('prop/table', 1, 1, 32, (p) => {
        legs(p, 0.14, 0.14, 0.72, 0.72, 24, 0.07, PAL.wood);
        p.box(0.1, 0.1, 24, 0.8, 0.8, 3, PAL.woodLight);
        // Checked plastic table cover.
        for (let a = 0; a < 4; a++)
            for (let b = 0; b < 4; b++)
                if ((a + b) % 2 === 0)
                    p.top(0.1 + a * 0.2, 0.1 + b * 0.2, 27.1, 0.2, 0.2, 0xd8e4ec);
    });
    for (const [name, color] of [['chair-white', PAL.plasticWhite], ['chair-red', PAL.plasticRed]]) {
        add(`prop/${name}`, 1, 1, 40, (p) => {
            legs(p, 0.28, 0.3, 0.44, 0.42, 15, 0.05, shade(color, 0.92));
            p.box(0.26, 0.24, 0, 0.48, 0.06, 36, color); // backrest
            p.box(0.26, 0.28, 15, 0.48, 0.46, 2.5, color);
        });
    }
    add('prop/stool', 1, 1, 18, (p) => {
        legs(p, 0.32, 0.32, 0.36, 0.36, 13, 0.06, PAL.wood);
        p.box(0.3, 0.3, 13, 0.4, 0.4, 3, PAL.woodLight);
    });
    add('prop/wardrobe', 1, 1, 76, (p) => {
        p.box(0.1, 0.12, 0, 0.8, 0.7, 72, shade(PAL.wood, 1.05), { edge: 0x3d2414 });
        p.line(0.5, 0.82, 4, 0.5, 0.82, 68, 0x3d2414, 0.8, 0.8);
        p.line(0.45, 0.82, 36, 0.45, 0.82, 42, 0xd9b26b, 1.4);
        p.line(0.55, 0.82, 36, 0.55, 0.82, 42, 0xd9b26b, 1.4);
    });
    add('prop/stove', 1, 1, 34, (p) => {
        p.box(0.14, 0.14, 0, 0.72, 0.72, 14, PAL.woodLight);
        p.cylinder(0.5, 0.5, 14, 0.18, 8, 0x2f5fa8); // kerosene stove
        p.cylinder(0.5, 0.5, 22, 0.24, 9, 0x3a3634); // pot of stew
        p.g.ellipse(p.px(0.5, 0.5), p.py(0.5, 0.5, 31), 6, 3).fill(0xb8341f);
    });
    add('prop/tv', 1, 1, 46, (p) => {
        p.box(0.15, 0.2, 0, 0.7, 0.6, 18, PAL.wood);
        p.box(0.2, 0.32, 18, 0.6, 0.3, 26, 0x26231f);
        p.poly([0.24, 0.62, 21, 0.76, 0.62, 21, 0.76, 0.62, 41, 0.24, 0.62, 41], 0x35506b);
    });
    add('prop/generator', 1, 1, 34, (p) => {
        p.box(0.14, 0.18, 0, 0.72, 0.64, 4, 0x2a2725);
        p.box(0.2, 0.24, 4, 0.6, 0.5, 14, 0x2e2c2a); // engine block
        p.box(0.12, 0.16, 0, 0.06, 0.68, 22, 0xc23b22); // frame bars
        p.box(0.82, 0.16, 0, 0.06, 0.68, 22, 0xc23b22);
        p.box(0.22, 0.24, 18, 0.56, 0.5, 9, 0xd9a21c); // fuel tank
        p.cylinder(0.72, 0.3, 18, 0.05, 12, 0x4d4a47); // exhaust
    });
    add('prop/drum', 1, 1, 40, (p) => {
        p.cylinder(0.5, 0.5, 0, 0.33, 34, PAL.drumBlue);
        p.g.ellipse(p.px(0.5, 0.5), p.py(0.5, 0.5, 34), 9, 4.5).fill(shade(PAL.drumBlue, 0.75));
    });
    add('prop/jerrycans', 1, 1, 26, (p) => {
        p.box(0.15, 0.15, 0, 0.3, 0.22, 20, 0xe4c11c);
        p.box(0.55, 0.2, 0, 0.3, 0.22, 20, 0xe4c11c);
        p.box(0.3, 0.55, 0, 0.3, 0.22, 20, 0xd3a915);
    });
    add('prop/bucket', 1, 1, 22, (p) => {
        p.cylinder(0.5, 0.5, 0, 0.22, 16, 0x3f86c6);
        p.g.ellipse(p.px(0.5, 0.5), p.py(0.5, 0.5, 16), 6.5, 3.2).fill(0x2a5c8a);
        p.g.moveTo(p.px(0.28, 0.5), p.py(0.28, 0.5, 16)).quadraticCurveTo(p.px(0.5, 0.5), p.py(0.5, 0.5, 26), p.px(0.72, 0.5), p.py(0.72, 0.5, 16)).stroke({ width: 0.8, color: 0x222222 });
    });
    add('prop/keke', 2, 1, 58, (p) => {
        const wheel = (x, y) => {
            p.g.ellipse(p.px(x, y), p.py(x, y, 5), 5, 5).fill(0x1c1a19);
            p.g.ellipse(p.px(x, y), p.py(x, y, 5), 2, 2).fill(0x8a8a8a);
        };
        wheel(0.35, 0.12);
        wheel(1.82, 0.5);
        p.box(0.12, 0.18, 6, 1.7, 0.64, 20, PAL.kekeYellow, { edge: 0x5a4512 });
        p.poly([0.12, 0.82, 14, 1.82, 0.82, 14, 1.82, 0.82, 19, 0.12, 0.82, 19], PAL.kekeGreen); // stripe
        p.box(1.55, 0.25, 26, 0.3, 0.5, 2, 0x2b2a28); // dashboard
        for (const [x, y] of [[0.16, 0.2], [0.16, 0.76], [1.7, 0.2], [1.7, 0.76]])
            p.box(x, y, 26, 0.04, 0.04, 22, 0x2b2a28);
        p.poly([1.74, 0.22, 30, 1.74, 0.78, 30, 1.74, 0.78, 46, 1.74, 0.22, 46], 0x9fb8c4, 0.55); // windscreen
        p.box(0.1, 0.14, 48, 1.72, 0.72, 4, 0x1f1d1c); // canopy
        p.poly([0.1, 0.86, 48, 1.82, 0.86, 48, 1.82, 0.86, 44, 0.1, 0.86, 44], PAL.kekeGreen);
        wheel(0.35, 0.88);
    });
    add('prop/bench', 3, 1, 22, (p) => {
        legs(p, 0.15, 0.32, 2.7, 0.36, 12, 0.07, PAL.wood);
        p.box(0.08, 0.28, 12, 2.84, 0.44, 3, PAL.woodLight);
    });
    add('prop/stall', 2, 2, 84, (p) => {
        for (const [x, y] of [[0.05, 0.05], [1.88, 0.05], [0.05, 1.88], [1.88, 1.88]])
            p.box(x, y, 0, 0.07, 0.07, 66, PAL.wood);
        p.box(0.25, 0.4, 0, 1.5, 1.1, 26, PAL.woodLight);
        const r = rng(11);
        const goods = [0xc9302c, 0xe0731d, 0x7a3b6e, 0xd9c36a, 0x3f8f3f];
        for (let i = 0; i < 14; i++) {
            const x = 0.35 + r() * 1.3;
            const y = 0.5 + r() * 0.9;
            p.g.ellipse(p.px(x, y), p.py(x, y, 29), 3.2, 2.2).fill(goods[i % goods.length]);
        }
        // Sloped corrugated zinc roof (rusty patches).
        p.poly([-0.06, -0.06, 70, 2.06, -0.06, 70, 2.06, 2.06, 60, -0.06, 2.06, 60], PAL.zinc);
        for (let i = 1; i < 10; i++) {
            const x = -0.06 + (2.12 * i) / 10;
            p.line(x, -0.06, 70, x, 2.06, 60, PAL.zincDark, 0.7, 0.8);
        }
        p.poly([1.2, 0.3, 68.6, 1.7, 0.3, 68.6, 1.7, 0.9, 65.8, 1.2, 0.9, 65.8], PAL.rust, 0.45);
        p.poly([-0.06, 2.06, 60, 2.06, 2.06, 60, 2.06, 2.06, 57, -0.06, 2.06, 57], PAL.zincDark);
    });
    add('prop/umbrella', 2, 2, 92, (p) => {
        p.box(0.5, 0.6, 0, 1.0, 0.7, 24, PAL.plasticWhite);
        p.box(0.98, 0.98, 0, 0.04, 0.04, 80, 0x555555);
        const cx = p.px(1, 1);
        const cy = p.py(1, 1, 80);
        const cols = [0xd94f3d, 0xf2c14e, 0x2e6fb7, 0x3f9b5b];
        for (let i = 0; i < 8; i++) {
            const a0 = (i / 8) * Math.PI * 2;
            const a1 = ((i + 1) / 8) * Math.PI * 2;
            p.g.poly([cx, cy - 10, cx + Math.cos(a0) * 58, cy + Math.sin(a0) * 26, cx + Math.cos(a1) * 58, cy + Math.sin(a1) * 26], true).fill(cols[i % 4]);
        }
    });
    add('prop/tree', 1, 1, 128, (p) => {
        p.box(0.4, 0.4, 0, 0.2, 0.2, 60, 0x5b3a22);
        const cx = p.px(0.5, 0.5);
        const cy = p.py(0.5, 0.5, 0);
        const r = rng(21);
        const greens = [0x3f6b2a, 0x4f7f32, 0x5f913a, 0x35592a];
        for (let i = 0; i < 14; i++) {
            const a = r() * Math.PI * 2;
            const d = r() * 22;
            p.g.circle(cx + Math.cos(a) * d, cy - 92 + Math.sin(a) * d * 0.6, 12 + r() * 8).fill(greens[i % 4]);
        }
        for (let i = 0; i < 5; i++)
            p.g.circle(cx - 10 + r() * 20, cy - 100 + r() * 16, 2.5).fill(0xe0a21c); // mangoes
    }, 14);
    add('prop/streetlamp', 1, 1, 128, (p) => {
        p.box(0.42, 0.42, 0, 0.16, 0.16, 4, 0x6b6b66);
        p.box(0.46, 0.46, 0, 0.08, 0.08, 116, 0x5f625f);
        p.line(0.5, 0.5, 116, 0.5, 0.95, 118, 0x5f625f, 2);
        p.g.ellipse(p.px(0.5, 0.95), p.py(0.5, 0.95, 114), 6, 3).fill(0xfff2c9);
    }, 8);
    add('prop/bathroom', 1, 1, 84, (p) => {
        p.box(0.04, 0.04, 0, 0.92, 0.92, 78, PAL.zinc);
        for (let i = 1; i < 6; i++)
            p.line(0.04 + i * 0.15, 0.96, 0, 0.04 + i * 0.15, 0.96, 78, PAL.zincDark, 0.6, 0.8);
        p.poly([0.3, 0.965, 0, 0.75, 0.965, 0, 0.75, 0.965, 64, 0.3, 0.965, 64], 0x3d2a1c); // door
        p.top(0.04, 0.04, 78.5, 0.92, 0.92, PAL.rust, 0.35);
    });
    add('prop/tank', 2, 2, 124, (p) => {
        legs(p, 0.2, 0.2, 1.6, 1.6, 60, 0.08, 0x5d5f5c);
        p.box(0.15, 0.15, 60, 1.7, 1.7, 3, 0x4d4f4c);
        p.cylinder(1, 1, 63, 0.7, 50, 0x232323);
    });
    return items;
}
/** Every world texture (floor, decals, walls, props) for the procedural "coal-camp-world" generator. */
export function worldArtItems() {
    return [...floorItems(), ...decalItems(), ...wallItems(), ...propItems()];
}
